import * as React from 'react';
import { Space, Tooltip, Image, Switch, Button, Popconfirm } from 'antd';
import { TableRow, TableCell } from '@mui/material';
import { UpOutlined, DownOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { SingleProductContext } from '../context/SingleProductContext';

export default function SKUItemRow({ skuItem, onEdit, onStockChange, onDelete }) {
  const { skuArrowUpHandler, skuArrowDownHandler } = React.useContext(SingleProductContext);
  return (
    <TableRow>
      <TableCell width={85}>
        <Space size={0}>
          <Tooltip title='เลื่อนขึ้น'>
            <Button type='link' icon={<UpOutlined />} size='small' onClick={() => skuArrowUpHandler(skuItem.id)} />
          </Tooltip>
          <Tooltip title='เลื่อนลง'>
            <Button type='link' icon={<DownOutlined />} size='small' onClick={() => skuArrowDownHandler(skuItem.id)} />
          </Tooltip>
        </Space>
      </TableCell>
      <TableCell width={85}>
        <Image width={50} height={50} style={{ objectFit: 'contain' }} src={skuItem.skuImage} alt='' />
      </TableCell>
      <TableCell>{skuItem.skuName}</TableCell>
      <TableCell>
        {skuItem.discountPrice ? (
          <>
            <div style={{ textDecoration: 'line-through' }}>{skuItem.mainPrice}</div>
            <div>{skuItem.discountPrice}</div>
          </>
        ) : (
          <div>{skuItem.mainPrice}</div>
        )}
      </TableCell>
      <TableCell>{skuItem.sku}</TableCell>
      <TableCell width={120}>
        <Switch checked={skuItem.inStock ? true : false} onChange={(e) => onStockChange(e, skuItem.id)} />
        <div>{skuItem.inStock ? 'in stock' : 'out of stock'}</div>
      </TableCell>
      <TableCell width={85}>
        <Space size={0}>
          <Tooltip title='Edit SKU'>
            <Button type='link' icon={<EditOutlined />} onClick={() => onEdit(skuItem.id)} />
          </Tooltip>
          <Tooltip title='Delete SKU'>
            <Popconfirm
              title='ลบ SKU นี้?'
              placement='bottom'
              okText='Yes'
              cancelText='No'
              onConfirm={() => onDelete(skuItem.id)}>
              <Button type='link' icon={<DeleteOutlined />} />
            </Popconfirm>
          </Tooltip>
        </Space>
      </TableCell>
    </TableRow>
  );
}
